import React, { useState, useEffect } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import moment from "moment";
import accessibility from "highcharts/modules/accessibility";

const MQTTChart = ({
  MQTTSmartNodeData,
  MQTTWhitelionData,
  MQTTSmartNodeTitle,
  MQTTWhitelionTitle,
}: any) => {
  accessibility(Highcharts);
  const [chartOptions, setChartOptions] = useState({
    chart: {
      type: "line",
    },
    title: {
      text: "",
    },
    yAxis: {
      title: {
        text: "", // Set yAxis title to empty string
      },
    },
    xAxis: {
      type: "category",
      categories: [], // Initialize with empty categories
    },
    series: [
      {
        name: "SMARTNODE",
        data: [],
      },
      {
        name: "WHITELION",
        data: [],
      },
      // {
      //     name: 'ALEXA',
      //     data: [],
      // },
      // {
      //     name: 'GOOGLE',
      //     data: [],
      // },
    ],
    credits: {
      enabled: false, // Disable Highcharts.com credits
    },
    accessibility: {
      enabled: true,
    },
  });

  useEffect(() => {
    const categories = MQTTSmartNodeData.map((item: any) =>
      moment(item.readingDate).format("YYYY-MM-DD")
    ); // Extract readingDate for XAxis categories
    const seriesData = MQTTSmartNodeData.map((item: any) => item.commandCount); // Extract commandCount for series data
    const seriesData1 = MQTTWhitelionData.map((item: any) => item.commandCount); // Extract commandCount for series data

    setChartOptions((options) => ({
      ...options,
      xAxis: {
        ...options.xAxis,
        categories: categories,
      },
      series: [
        {
          ...options.series[0],
          name: MQTTSmartNodeTitle,
          data: seriesData,
        },
        {
          ...options.series[1],
          name: MQTTWhitelionTitle,
          data: seriesData1,
        },
      ],
    }));
  }, [MQTTSmartNodeData]);

  return (
    <div>
      <HighchartsReact highcharts={Highcharts} options={chartOptions} />
    </div>
  );
};

export default MQTTChart;
